import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: "error-popup",
  templateUrl: "error.component.html"
})
export class ErrorComponent {
  @Input()
  public data: any;

  constructor(public activeModal: NgbActiveModal) {
  }
}
